import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { SettingsUsersRequests } from './users.requests';

import { User } from '@core/objects/user';
import { SeatSetting } from '@core/objects/seat';

import * as fromStore from './users.state';
import * as fromActions from './users.actions';

@Injectable()
export class SettingsUsersEffects {

    constructor(private actions$: Actions, private store$: Store<fromStore.SettingsUsers>, private usersReq: SettingsUsersRequests) {}

    
    public loadAllUsers$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadAllUsers>(fromActions.SettingsUsersActionType.LoadAllUsers),
        switchMap(() => {
            return this.usersReq.loadAllUsers$().pipe(
                map((users: User[]) => {
                    return new fromActions.LoadAllUsersSuccess(users);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadAllUsersError());
                })
            );
        })
    ));

    
    public loadAllUsersSuccess$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadAllUsersSuccess>(fromActions.SettingsUsersActionType.LoadAllUsersSuccess),
        mergeMap((action) => {
            return of(new fromActions.SetAllUsers(action.users));
        })
    ));
    
    public addNewInvitation$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.AddNewInvitation>(fromActions.SettingsUsersActionType.AddNewInvitation),
        //  withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        mergeMap((action) => {
            return this.usersReq.addNewInvitation$(action.name, action.email, action.message, action.groups, action.extra).pipe(
                map(() => {
                    return new fromActions.AddNewInvitationSuccess();
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.AddNewInvitationError(err));
                })
            );
        })
    ));

    
    public addNewInvitationSuccess$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.AddNewInvitationSuccess>(fromActions.SettingsUsersActionType.AddNewInvitationSuccess),
        mergeMap(() => {
            return of(new fromActions.LoadAllUsersSeats());
        })
    ));

    
    public deleteOneUser$ : Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.DeleteOneUser>(fromActions.SettingsUsersActionType.DeleteOneUser),
        //  withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        mergeMap((action) => {
            return this.usersReq.deleteOneUser$(action.id).pipe(
                map(() => {
                    return new fromActions.DeleteOneUserSuccess()
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.DeleteOneUserError());
                })
            );
        })
    ));


    
    public deleteOneUserError$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.DeleteOneUserError>(fromActions.SettingsUsersActionType.DeleteOneUserError),
        mergeMap(() => {
            return of(new fromActions.LoadAllUsers(),new fromActions.LoadAllUsersSeats());
        })
    ));

    
    public deleteInvitation$ : Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.DeleteInvitation>(fromActions.SettingsUsersActionType.DeleteInvitation),
        //  withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        mergeMap((action) => {
            return this.usersReq.deleteInvitation$(action.email).pipe(
                map(() => {
                    return new fromActions.DeleteInvitationSuccess();
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.DeleteInvitationError());
                })
            );
        })
    ));

    // Reaload all users only when delete invitation throw an error to get real users again
    public deleteInvitationError$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.DeleteInvitationError>(fromActions.SettingsUsersActionType.DeleteInvitationError),
        mergeMap(() => {
            return of(new fromActions.LoadAllUsersSeats());
        })
    ));

    // SEATS
    public loadAllUsersSeats$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadAllUsersSeats>(fromActions.SettingsUsersActionType.LoadAllUsersSeats),
        //  withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        switchMap(() => {
            return this.usersReq.loadAllSeats$().pipe(
                map((seats: SeatSetting[]) => {
                    return new fromActions.LoadAllUsersSeatsSuccess(seats);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadAllUsersSeatsError(err));
                })
            );
        })
    ));

    
    public loadAllUsersSeatsSuccess$: Observable<fromActions.SettingsUsersActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadAllUsersSeatsSuccess>(fromActions.SettingsUsersActionType.LoadAllUsersSeatsSuccess),
        mergeMap((action) => {
            return of(new fromActions.SetAllUsersSeats(action.seats));
        })
    ));
}
